import RecipesTable from './RecipesTable';

export default RecipesTable;
